/*
 * Title: 회원초대 서비스
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */
import GentleServiceIntro from '../service/intro';
import GentleServiceProduct from '../service/product';
import GentleServiceAccount from '../service/account';
import GentleServiceHelp from '../service/help';
import GentleServiceFallback from '../service/fallback';
import GentleServiceProfile from '../service/profile';
import GentleServiceInviteMember from '../service/inviteMember';
import GentleServiceSales from '../service/sales';
import GentleServiceBonus from './bonus';
import GentleServiceSearch from '../service/search';
import GentleServiceOrder from '../service/order';
import GentleServiceNotice from '../service/notice';
import GentleServiceSchedule from '../service/schedule';
import GentleServiceCallCenter from '../service/callCenter';
import GentleServiceJoin from '../service/join';
import GentleServiceApprove from '../service/approve';
import GentleServiceEditSaleDate from '../service/editSaleDate';
import GentleServiceCart from '../service/cart';
import GentleServiceMarketingPlan from '../service/marketingPlan';
import GentleServiceHome from '../service/home';
import GentleServiceTip from '../service/tip';
import GentleUtil from '../common/util';
import GentleServiceError from '../service/error';
import GentleComponentBubble from '../component/bubble';
import GentleAppState from '../common/appstate';
import GentleServiceConsulting from '../service/consulting'

var GentleServiceCustomHandler = Object.create( {} );

GentleServiceCustomHandler.onInput = function(text){
    // console.log('사용자발화 ', text)

    // test를 지원하기 위한 코드
    {
        if(GentleAppState.useBrity === false)
        {
            // window.ChatConsole.loadingBox(true);

            let service;
            let param = {};


            // 테스트용 
            switch(text){   
            case '상담하기':
                service = 'GentleServiceCallCenter.info';
                break;        
            case '인트로':
            case 'intro':
                service = 'GentleServiceIntro.introInit';
                param = {ignoreCookie:true, skipAppLoading:true/*, startScene:'scene-papa-12'*/};
                break;
            case '일정':
            case '일정조회':
            case '나의 스케줄 보기':
            case 'schedule':
                service = 'GentleServiceSchedule.main';
            break;            
            case '프로필등록':
            case '프로필 작성':
            case 'Profile registration':
                service = 'GentleServiceProfile.main';
            break;            
            case 'GentleServiceTip.whatdo':
                service = 'GentleServiceTip.whatdo';
                break;            
            case '처음으로':
            case 'home':
            case 'to the first step':
                service = 'GentleServiceHome.main';
                break;
            case '타기간 후원수당 발생내역':
            case '후원수당 발생내역':
            case 'Occurrence history of general commission':
                service = 'GentleServiceBonus.huwonBonusOccurrence';
                break;
            case '마켓팅플랜':
            case 'Marketing plan description':
                service = 'GentleServiceMarketingPlan.main';
                break;
            case '신상품 목록':
            case 'Inquiry of new products':
                service = 'GentleServiceProduct.newList';
                break;
            case '세미나 일정':
            case '세미나 일정 보기':
            case 'Seminar schedule inquiry':
                service = 'GentleServiceSchedule.seminar';
                break;
            case '직급내역':
            case 'Mastership History':
                service = 'GentleServiceBonus.positionPay';
                break;
            case '후원수당':
                service = 'GentleServiceBonus.huwonBonus';
                break;
            case '소실적 맞춤 상품 추천':
            case '소실적 추천상품':
            case 'Recommend products tailored to your needs':
                service = 'GentleServiceSales.recommend';
                break;
            case '나의 매출':
            case 'Sales Inquiry':
                service = 'GentleServiceSales.popupMySales';
                break;
            case '장바구니':
            case 'Shopping cart':
                service = 'GentleServiceCart.main';
                break;
            case '로그아웃':
            case 'Log out':
                service = 'GentleServiceAccount.logoutEntry';
                break;
            case '승인잔액조회':
            case '승인잔액 조회':
            case 'Inquiry of Approval Balance':
                service = 'GentleServiceApprove.main';
                break;
            case '회원가입안내':
            case 'Sign Up':
                service = 'GentleServiceJoin.main';
                break;
            case '센터 정보 찾기':
                service = 'GentleServiceJoin.location';
                break;
            case '고객센터 연결':
            case 'Kakao talk consultation connection':
                service = 'GentleServiceCallCenter.info';
                break;
            case '공지사항':
            case 'Notice inquiry':
                service = 'GentleServiceNotice.main';
                break;            
            case '비회원':
                service = 'GentleServiceOrder.showForm';
                break;
            case '주문내역':
            case '주문내역조회':
            case '주문내역 보기':
            case 'Order history':
                service = 'GentleServiceOrder.main';
                break;
            case '상품검색':
            case 'Product search':
                service = 'GentleServiceSearch.main';
                break;
            case '수당내역':
            case '수당조회':
            case 'Commission inquiry':
            case 'Benefits':
                service = 'GentleServiceBonus.main';
                break;
            case '매출조회':
            case '매출보기':
            case '하위 매출 보기':
            case 'Sales inquiry':
                service = 'GentleServiceSales.main';
                break;
            case '회원초대':
            case 'Member invitation':
                service = 'GentleServiceInviteMember.main';
                break;
            case '프로필수정':
            case 'Edit Profile':
                service = 'GentleServiceProfile.edit';
                break;
            case '하위회원로그인':
            case 'Downliner login':
                service = 'GentleServiceAccount.lowerList';
                break;
            case '로그인':
            case 'Log in':
                service = 'GentleServiceAccount.login';
                break;
            case '관심회원목록':
                service = 'GentleServiceAccount.lowerList';
                break;
            // case '인기상품':
            // case '애터미 인기상품 보기':
            // case 'Search for popular products':
            //     service = 'GentleServiceProduct.bestList';
            //     break;
            case '신상품':
            case '신상품조회':
            case '애터미 신상품 보기':
            case 'Inquiry of new products':
                service = 'GentleServiceProduct.newList';
                break;
            case '주문목록':
            case 'Order history':
                service = 'GentleServiceProduct.orderList';
                break;
            default:
                console.log('Nof found service');
                return;
            }
            
            GentleServiceCustomHandler.handler({service, intro: param});
        }
    }
}

GentleServiceCustomHandler.handler = function(json)
{
    // console.log('GentleServiceInputHandler>',json);
    const {service, token} = json;
    console.log('service>', service);
    
    if(!window.chatbotHistory) window.chatbotHistory = [];

    try{
        window.ChatConsole.loadingBox(false);
    
        const service = json.service.trim();
        const {speech} = json;

        if(speech) GentleComponentBubble.insertUserBubble({html: speech, send:false})

        const obj = {
            type: 'service'
        }

        switch(service){    
        case 'GentleServiceConsulting.insertReview':
            GentleServiceConsulting.insertReview();
            break;
        case 'GentleServiceConsulting.TalkAvailable':
            GentleServiceConsulting.TalkAvailable();
            break;
        case 'GentleServiceOrder.showForm':
            GentleServiceOrder.showForm();
            break;
        case 'GentleServiceTip.plan':
            GentleServiceTip.plan();
            obj.name = '플랜';
        break;            
        case 'GentleServiceTip.profile':
            GentleServiceTip.profile();
            obj.name = '프로필편집';
        break;            
        case 'GentleServiceTip.invite':
            GentleServiceTip.invite();
            obj.name = '회원초대';
        break;            
        case 'GentleServiceTip.whatdo':
            GentleServiceTip.whatdo();
            break;            
        case 'GentleServiceIntro.introInit':
            GentleServiceIntro.introInit(json);
            break;    
        case 'GentleServiceHome.main':
            GentleServiceHome.main();
            break;
        case 'GentleServiceBonus.huwonBonusOccurrence':
            GentleServiceBonus.huwonBonusOccurrence();
            obj.name = '후원수당발생';
            break;
        case 'GentleServiceMarketingPlan.main':
            GentleServiceMarketingPlan.main();
            obj.name = '마켓팅플랜';
            break;
        case 'GentleServiceProduct.new':
            //신상품은 추후에 다시 여는것으로 변경
            // GentleServiceProduct.newList(json);
            // obj.name = '신상품';
            GentleServiceSearch.main();
            obj.name = '상품검색';
            break;
        case 'GentleServiceSchedule.seminar':
            GentleServiceSchedule.seminar();
            obj.name = '세미나';
            break;
        case 'GentleServiceBonus.positionPay':
            GentleServiceBonus.positionPay(json);
            obj.name = '직급수당';
            break;
        case 'GentleServiceBonus.huwonBonus':
            GentleServiceBonus.huwonBonus(json);
            obj.name = '후원수당';
            break;
        case 'GentleServiceSales.recommend':
            GentleServiceSales.recommend();
            obj.name = '소실적 맞춤 추천상품';
            break;
        case 'GentleServiceSales.popupMySales':
            GentleServiceSales.popupMySales();
            obj.name = '나의 매출내역';
            break;
        // case 'GentleServiceAccount.loginCheck':
        //     GentleServiceAccount.loginCheck();
            break;
        case 'GentleServiceCart.main':
            GentleServiceCart.main();
            obj.name = '장바구니';
            break;
        case 'GentleServiceAccount.sso':
            GentleServiceAccount.sso(decodeURIComponent(token));
            // console.log("decode >>>>", decodeURIComponent(token))
            break;
        case 'GentleServiceAccount.logoutEntry':
            GentleServiceAccount.logoutEntry();
            break;
        case 'GentleServiceEditSaleDate.main':
            GentleServiceEditSaleDate.main();
            obj.name = '판매일자변경';
            break;
        case 'GentleServiceApprove.main':
            GentleServiceApprove.main();
            obj.name = '승인내역';
            break;
        case 'GentleServiceJoin.main':
            GentleServiceJoin.main();
            obj.name = '회원가입';
            break;
        case 'GentleServiceJoin.location':
            GentleServiceJoin.location();
            obj.name = '지역별지점안내';
            break;
        case 'GentleServiceCallCenter.info':
            GentleServiceCallCenter.info();
            obj.name = '상담사연결';
            break;
        case 'GentleServiceCallCenter.main':
            GentleServiceCallCenter.main();
            obj.name = '고객센터';
            break;
        case 'GentleServiceCallCenter.chat':
            GentleServiceCallCenter.chat();
        break;
        case 'GentleServiceSchedule.main':
            GentleServiceSchedule.main();
            obj.name = '나의일정';
            break;
        case 'GentleServiceNotice.main':
            GentleServiceNotice.main();
            obj.name = '공지사항';
            break;
        case 'GentleServiceOrder.main':
            GentleServiceOrder.main(json);
            obj.name = '주문내역';
            break;
        case 'GentleServiceSearch.main':
            GentleServiceSearch.main();
            obj.name = '상품검색';
            break;
        case 'GentleServiceBonus.main':
            GentleServiceBonus.main();
            obj.name = '수당내역';
            break;
        case 'GentleServiceSales.main':
            GentleServiceSales.main();
            obj.name = '하위매출조회';
            break;
        case 'GentleServiceInviteMember.main':
            GentleServiceInviteMember.main();
            obj.name = '회원초대';
            break;
        case 'GentleServiceProfile.main':
            GentleServiceProfile.main();
            obj.name = '나의 프로필';
            break;
        case 'GentleServiceProfile.edit':
            GentleServiceProfile.edit();
            obj.name = '프로필 편집';
            break;
        case 'GentleServiceAccount.logout':
            GentleServiceAccount.logout();
            obj.name = '로그아웃';
            break;
        case 'GentleServiceAccount.login':
            GentleServiceAccount.login(json);
            obj.name = '로그인';
            break;
        case 'GentleServiceAccount.lowerList':
            GentleServiceAccount.lowerList();
            obj.name = '하위멤버목록';
            break;
        case 'GentleServiceProduct.bestList':
            GentleServiceSearch.main();
            obj.name = '상품검색';
            // GentleServiceProduct.bestList(json);
            // obj.name = '인기상품목록';
            // 인기상품 목록 (Dev, local)
            break;
        case 'GentleServiceProduct.newList':
            GentleServiceProduct.newList(json);
            obj.name = '신상품목록';
            break;
        case 'GentleServiceProduct.orderList':
            json.nextService = 'GentleServiceOrder.main'
            GentleServiceProduct.orderList(json);
            obj.name = '주문목록';
            break;
        case 'GentleServiceHelp.help':
            GentleServiceHelp.help();
            break;
        case 'GentleServiceFallback.fallbackThird':
            GentleServiceFallback.fallbackThird(json);
            break;
        default:
            GentleServiceError.createErrorHandler('service', new Error('Not found service'));
            //console.log('Nof found service');
        }   


        if(obj.name)
        {
            let botCreatedDate = '';
            {
                var date = new Date();
                var year = date.getFullYear().toString();
            
                var month = date.getMonth() + 1;
                month = month < 10 ? '0' + month.toString() : month.toString();
            
                var day = date.getDate();
                day = day < 10 ? '0' + day.toString() : day.toString();
            
                var hour = date.getHours();
                hour = hour < 10 ? '0' + hour.toString() : hour.toString();
            
                var minites = date.getMinutes();
                minites = minites < 10 ? '0' + minites.toString() : minites.toString();
            
                var seconds = date.getSeconds();
                seconds = seconds < 10 ? '0' + seconds.toString() : seconds.toString();
            
                botCreatedDate = year + month + day + hour + minites + seconds;
            }
            gentleApp.addHistory({
                message: obj.name, 
                botCreatedDate,
                senderFlag: 'B'
            });
        }

    }catch(err){
         GentleServiceError.createErrorHandler('service', err);
    }
}
export default GentleServiceCustomHandler;